import type { RefObject } from 'react';
import { useEffect } from 'react';

/** Запрещает курсору находиться на префиксе телефона '+7 (' */
export const usePrefixSelection = (inputRef: RefObject<HTMLInputElement>, prefix: string) => {
    useEffect(() => {
        const input = inputRef.current;
        const correctPrefixSelection = () => {
            /* istanbul ignore next */
            if (!input || input.selectionStart === null) return;

            if (input.selectionStart < prefix.length) {
                const { length } = prefix;

                const selectionEnd = input.selectionEnd || 0;
                const positionEnd = selectionEnd < length ? length : selectionEnd;
                input.setSelectionRange(length, positionEnd);
            }
        };

        if (input) {
            input.addEventListener('select', correctPrefixSelection);
            input.addEventListener('click', correctPrefixSelection);
        }

        return () => {
            if (input) {
                input.removeEventListener('select', correctPrefixSelection);
                input.removeEventListener('click', correctPrefixSelection);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
